// extracted by mini-css-extract-plugin
module.exports = {"plants":"AvailablePlants_plants__27v2l","meals-appear":"AvailablePlants_meals-appear__37qt6"};